import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { feedbackService, CreateFeedbackRequest } from '@/services/feedback.service'
import { toast } from 'sonner'
import { getErrorMessage } from '@/utils/error'

export function useSubmitFeedback() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateFeedbackRequest) => feedbackService.submitFeedback(data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feedback', 'mine', variables.courseId] })
      toast.success('Feedback enviado com sucesso!')
    },
    onError: (error: unknown) => {
      toast.error(getErrorMessage(error, 'Erro ao enviar feedback'))
    },
  })
}

export function useMyFeedback(courseId: number) {
  return useQuery({
    queryKey: ['feedback', 'mine', courseId],
    queryFn: () => feedbackService.getMyFeedback(courseId),
    enabled: !!courseId,
  })
}
